(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4671],{

/***/ 11882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v2": function() { return /* binding */ baseURL; },
  "Jl": function() { return /* binding */ deleteRequest; },
  "A_": function() { return /* binding */ getRequest; },
  "Ft": function() { return /* binding */ patchResquest; },
  "j0": function() { return /* binding */ postRequest; }
});

// UNUSED EXPORTS: apiClient, getFileRequest, putRequest

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./shared/models/functions/create-formdata.helper.ts
function createFormData(jsonObject, parentKey, carryFormData) {
  var formData = carryFormData || new FormData();
  var index = 0;

  for (var _key in jsonObject) {
    if (Object.prototype.hasOwnProperty.call(jsonObject, _key)) {
      if (jsonObject[_key] !== null && jsonObject[_key] !== undefined) {
        var propName = parentKey || _key;

        if (parentKey && _isObject(jsonObject)) {
          propName = parentKey + "[".concat(_key, "]");
        }

        if (parentKey && Array.isArray(jsonObject)) {
          propName = parentKey + "[".concat(index, "]");
        }

        if (jsonObject[_key] instanceof File) {
          formData.append(propName, jsonObject[_key]);
        } else if (jsonObject[_key] instanceof FileList) {
          for (var j = 0; j < jsonObject[_key].length; j++) {
            formData.append(propName + "[".concat(j, "]"), jsonObject[_key].item(j));
          }
        } else if (Array.isArray(jsonObject[_key]) || _isObject(jsonObject[_key])) {
          createFormData(jsonObject[_key], propName, formData);
        } else if (typeof jsonObject[_key] === "boolean") {
          formData.append(propName, +jsonObject[_key] ? "1" : "0");
        } else {
          formData.append(propName, jsonObject[_key]);
        }
      }

      index++;
    }
  }

  return formData;
}

function _isObject(val) {
  return !Array.isArray(val) && typeof val === "object" && !!val;
}
// EXTERNAL MODULE: ./shared/services/auth.service.ts
var auth_service = __webpack_require__(84100);
;// CONCATENATED MODULE: ./api/base-services.request.ts




var baseURL = "https://api.remaxrd.com";
var apiKey = "95ac554a9df925bdc63c8b34d43ed5a162770c3630a0543ce7b4880d56c2778619abe5c8ad2cf9647099cfab0cd10112c4133cbc8521cedb14ae5f57fcd32a42$2" + "$2";
var apiClient = axios_default().create({
  baseURL: baseURL,
  headers: {
    "Content-type": "application/json",
    "access-control-allow-origin": "*",
    "x-api-key": apiKey,
    "x-requested-with": "XMLHttpRequest"
  },
  paramsSerializer: function paramsSerializer(params) {
    return lib_default().stringify(params, {
      encode: false
    });
  }
});
var getRequest = function getRequest(endPoint, filters) {
  var headers = getAuthHeader();
  return apiClient.get("".concat(endPoint), {
    params: filters,
    headers: headers
  });
};
var postRequest = function postRequest(endPoint, body, useFormData) {
  var formBody = body;
  var headers = getAuthHeader();
  if (useFormData) formBody = createFormData(body);
  return apiClient.post("".concat(endPoint), formBody, {
    headers: headers
  });
};
var putRequest = function putRequest(endPoint, body) {
  return apiClient.post("".concat(endPoint), body);
};
var deleteRequest = function deleteRequest(endPoint) {
  var headers = getAuthHeader();
  return apiClient["delete"](endPoint, {
    headers: headers
  });
};
var getFileRequest = function getFileRequest(endPoint) {
  return apiClient.get("".concat(endPoint), {
    responseType: "blob"
  });
};
var patchResquest = function patchResquest(endPoint, body) {
  var headers = getAuthHeader();
  return apiClient.patch(endPoint, body, {
    headers: headers
  });
};

function getAuthHeader() {
  var token = (0,auth_service/* getUserToken */.N)();
  return token ? {
    Authorization: "Bearer " + token
  } : undefined;
}

/***/ }),

/***/ 65198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function useDataLayerEvent() {
  var event = function event(info) {
    var Widows = window;

    if (typeof Widows.dataLayer != 'undefined' && typeof Widows != 'undefined') {
      Widows.dataLayer.push(_objectSpread({
        event: info.event_name
      }, info));
      console.log("dataLayer event", info);
    }
  };

  return {
    event: event
  };
}

/* harmony default export */ __webpack_exports__["Z"] = (useDataLayerEvent);

/***/ }),

/***/ 53541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);


function useGetPersistParams(config) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)(); // if (config?.onlyId) {
  //   if (router?.query?.referer) {
  //     return router?.query?.referer as string;
  //   } else if (router?.query?.areferer) {
  //     return router?.query?.areferer as string;
  //   }
  // } else

  if (!(config !== null && config !== void 0 && config.onlyCode)) {
    var _router$query5, _router$query7;

    if (config !== null && config !== void 0 && config.onlyId) {
      var _router$query, _router$query3;

      if (router !== null && router !== void 0 && (_router$query = router.query) !== null && _router$query !== void 0 && _router$query.referer) {
        var _router$query2;

        return router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.referer;
      } else if (router !== null && router !== void 0 && (_router$query3 = router.query) !== null && _router$query3 !== void 0 && _router$query3.areferer) {
        var _router$query4;

        return router === null || router === void 0 ? void 0 : (_router$query4 = router.query) === null || _router$query4 === void 0 ? void 0 : _router$query4.areferer;
      }
    } else if (router !== null && router !== void 0 && (_router$query5 = router.query) !== null && _router$query5 !== void 0 && _router$query5.referer) {
      var _config$useConque, _router$query6;

      return "".concat((_config$useConque = config === null || config === void 0 ? void 0 : config.useConque) !== null && _config$useConque !== void 0 ? _config$useConque : "?", "referer=").concat(router === null || router === void 0 ? void 0 : (_router$query6 = router.query) === null || _router$query6 === void 0 ? void 0 : _router$query6.referer);
    } else if (router !== null && router !== void 0 && (_router$query7 = router.query) !== null && _router$query7 !== void 0 && _router$query7.areferer) {
      var _config$useConque2, _router$query8;

      return "".concat((_config$useConque2 = config === null || config === void 0 ? void 0 : config.useConque) !== null && _config$useConque2 !== void 0 ? _config$useConque2 : "?", "areferer=").concat(router === null || router === void 0 ? void 0 : (_router$query8 = router.query) === null || _router$query8 === void 0 ? void 0 : _router$query8.areferer);
    }
  } else {
    var _router$query9, _router$query11;

    if (router !== null && router !== void 0 && (_router$query9 = router.query) !== null && _router$query9 !== void 0 && _router$query9.referer) {
      var _router$query10;

      return {
        referer: router === null || router === void 0 ? void 0 : (_router$query10 = router.query) === null || _router$query10 === void 0 ? void 0 : _router$query10.referer
      };
    } else if (router !== null && router !== void 0 && (_router$query11 = router.query) !== null && _router$query11 !== void 0 && _router$query11.areferer) {
      var _router$query12;

      return {
        areferer: router === null || router === void 0 ? void 0 : (_router$query12 = router.query) === null || _router$query12 === void 0 ? void 0 : _router$query12.areferer
      };
    }
  }

  return "";
}

/* harmony default export */ __webpack_exports__["Z"] = (useGetPersistParams);

/***/ }),

/***/ 71652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var notistack__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50841);


var _excluded = ["enqueueSnackbar"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var defaultOptions = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right"
  },
  autoHideDuration: 3000
};

function useSnackBar() {
  var _useSnackbar = (0,notistack__WEBPACK_IMPORTED_MODULE_1__/* .useSnackbar */ .Ds)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useSnackbar, _excluded);

  var showMessage = function showMessage(message, options) {
    enqueueSnackbar(message, _objectSpread(_objectSpread({}, defaultOptions), options));
  };

  return _objectSpread({
    showMessage: showMessage
  }, rest);
}

/* harmony default export */ __webpack_exports__["Z"] = (useSnackBar);

/***/ }),

/***/ 47364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18872);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


var _excluded = ["message"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function LoadingBubbles(props) {
  var _props$message = props.message,
      message = _props$message === void 0 ? "Cargando más" : _props$message,
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Loading, rest, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", {
    style: {
      marginRight: 15
    }
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("img", {
    src: "/icons/loading-icon.svg",
    alt: "loading"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("div", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("span", null, message)));
}

/* harmony default export */ __webpack_exports__["Z"] = (LoadingBubbles);
var spinner = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)( true ? {
  name: "b7n1on",
  styles: "0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"
} : 0);
var centerStyles = "\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 9999;\n";

var Loading = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e76jmd50"
} : 0)(function (props) {
  return "\n  width: 100%;\n  background-color: \"transparent\";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 15px;\n  font-weight: 600;\n  color:gray;\n   & img {\n    animation: ".concat(spinner, " 2s infinite;\n  }\n  ").concat(props.center ? centerStyles : '', "\n");
},  true ? "" : 0);

/***/ }),

/***/ 74232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ user_settings; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
;// CONCATENATED MODULE: ./custom-hooks/use-user-settings-menu-items.hook.ts


var menu = [];
var locale;
function useUserSettingsMenuItems() {
  var t = (0,next_intl_cjs_production_min.useTranslations)("SettingsLayout");
  var currentLocale = (0,next_intl_cjs_production_min.useLocale)();
  if (locale !== currentLocale) menu = [];
  if (menu.length) return menu;
  menu = [{
    slug: t("links.header_personal-info"),
    link: pages_path/* CPagesPath.es.profile */.K.es.profile,
    icon: "/icons/user-profile.svg",
    style: "bold",
    children: [{
      slug: t("links.edit-profile"),
      link: pages_path/* CPagesPath.es.profileEditar */.K.es.profileEditar
    }, {
      slug: t("links.change-password"),
      link: pages_path/* CPagesPath.es.profileCambiarClave */.K.es.profileCambiarClave
    }]
  }, {
    slug: t("links.header_favorites-list"),
    icon: "/icons/favorites-list.svg",
    style: "bold",
    link: pages_path/* CPagesPath.es.profileFavorites */.K.es.profileFavorites
  }, {
    slug: t("links.header_search-history"),
    icon: "/icons/search-query-list.svg",
    style: "bold",
    link: pages_path/* CPagesPath.es.ProfileSearchHistory */.K.es.ProfileSearchHistory
  }, {
    slug: t("links.history"),
    icon: "/icons/search-query-list.svg",
    style: "bold",
    link: pages_path/* CPagesPath.es.ProfileLastedSee */.K.es.ProfileLastedSee
  }];
  return menu;
}
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/layouts/user-settings/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function UserSettingsLayout(_ref) {
  var children = _ref.children;
  var t = (0,next_intl_cjs_production_min.useTranslations)("SettingsLayout");
  var menu = useUserSettingsMenuItems();

  var _user = (0,redux_hooks/* useAppSelector */.C)(function (state) {
    return state.Auth.user;
  });

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Container, null, _user && (0,emotion_react_browser_esm/* jsx */.tZ)("aside", {
    className: "sidebar"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, t("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(RecursiveItems, {
    items: menu
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: "main"
  }, children));
}

function RecursiveItems(_ref2) {
  var items = _ref2.items,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? 0 : _ref2$padding;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, items.map(function (item) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      style: {
        paddingLeft: padding
      },
      className: padding == 0 ? "root" : "node",
      key: item.slug
    }, item.link ? (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: item.link
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
      className: "link-tag"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, {
      item: item
    }))), item.children && (0,emotion_react_browser_esm/* jsx */.tZ)(RecursiveItems, {
      items: item.children,
      padding: padding + 30
    })) : (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, {
      item: item
    }, item.children && (0,emotion_react_browser_esm/* jsx */.tZ)(RecursiveItems, {
      items: item.children,
      padding: padding + 30
    })));
  }));
}

function ItemLabel(_ref3) {
  var _ref3$item = _ref3.item,
      icon = _ref3$item.icon,
      slug = _ref3$item.slug,
      style = _ref3$item.style,
      children = _ref3.children;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: [style !== null && style !== void 0 ? style : "thin", "label"].join(" ")
  }, typeof icon === "string" ? (0,emotion_react_browser_esm/* jsx */.tZ)((image_default()) // style={{paddingRight: "9"}}
  , {
    src: icon,
    alt: slug + " icon",
    width: 17,
    height: 17
  }) : icon && (0,emotion_react_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
    component: icon,
    inheritViewBox: true
  }), "\xA0", slug), children);
}

var Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efk798q0"
} : 0)( true ? {
  name: "bq82os",
  styles: "display:grid;grid-template-columns:250px 1fr;min-height:var(--main-height);.root{margin:20px 0 10px;}.node{margin-top:10px;}.link-tag{&:hover{text-decoration:underline;}}.label{display:flex;align-items:center;.bold{font-weight:700;color:var(--color-main-blue);}}.sidebar{padding:20px;background:#fafafa;overflow-y:auto;a{display:block;font-size:16px;margin-bottom:5px;}}@media (max-width: 899px){grid-template-columns:100%;aside.sidebar{display:none;}}"
} : 0);

/* harmony default export */ var user_settings = (UserSettingsLayout);

/***/ }),

/***/ 1283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CPagesPath; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var UniversalLinks = {
  blog: "https://blog.remaxrd.com/"
};
var es = {
  home: "/",
  collection: "/collection",
  collection_properties: "/collection/propiedades",
  collection_agents_list: "/collection/agentes",
  collection_property_detail: function collection_property_detail(x) {
    return "/collection/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x.slug);
  },
  collection_agent_detail: function collection_agent_detail(x) {
    return "/collection/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  properties: "/propiedades",
  shop: "/propiedades/comprar",
  acquire: "/propiedades/alquilar",
  property_detail: function property_detail(x) {
    return "/propiedad/".concat(RealestateEncode(x.realstate_type), "/").concat(x === null || x === void 0 ? void 0 : x.slug);
  },
  project: "/proyectos",
  project_Detail: function project_Detail(x) {
    return "/proyecto/".concat(x.slug);
  },
  loan_form: "/prestamos/formulario",
  loan_mortgage: "/prestamos/hipotecarios",
  loan_calculator: "/prestamos/calculadora",
  franchises: "/franquicias",
  agents_list: "/listado/agentes",
  agent_detail: function agent_detail(x) {
    return "/agente/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  agencies_list: "/listado/agencias",
  agency_detail: function agency_detail(x) {
    return "/agencia/".concat(HEncodeString(x.name), "/").concat(x.id);
  },
  frequent_questions: "/preguntas-frecuentes",
  join: "/agentes",
  termsAndCondition: "/terminos-condiciones",
  privacyPolitics: "/politica-privacidad",
  signin: "/acceder",
  profile: "/perfil",
  profileEditar: "/perfil/configuracion/editar-perfil",
  profileCambiarClave: "/perfil/configuracion/cambiar-clave",
  profileFavorites: "/perfil/configuracion/favoritos",
  ProfileSearchHistory: "/perfil/configuracion/busquedas",
  ProfileLastedSee: "/perfil/configuracion/historial-busquedas",
  signup: "/registrate",
  forgotPassword: "/restaurar-clave"
};
var CPagesPath = _objectSpread(_objectSpread({}, UniversalLinks), {}, {
  es: es
});

var HEncodeString = function HEncodeString(x) {
  return "".concat(x.replace(/\//g, "-").split(" ").join("-").toLowerCase());
};

var RealestateEncode = function RealestateEncode(x) {
  var _x$replaceAll;

  return x === null || x === void 0 ? void 0 : (_x$replaceAll = x.replaceAll("/", "o")) === null || _x$replaceAll === void 0 ? void 0 : _x$replaceAll.replaceAll(" ", "-").toLowerCase();
};

/***/ }),

/***/ 84100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ userState; },
/* harmony export */   "N": function() { return /* binding */ getUserToken; }
/* harmony export */ });
function userState() {
  var user = getLocalStorageItem("user");
  var parsedUser = null;

  if (user) {
    try {
      parsedUser = JSON.parse(user);
    } catch (e) {
      console.error("Error parsing user");
    }
  }

  return parsedUser;
}
function getUserToken() {
  var token = getLocalStorageItem("token");
  return token;
}

function getLocalStorageItem(key) {
  var item = null;

  if (true) {
    item = localStorage.getItem(key);
  }

  return item;
}

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);